import React from 'react'

import Table from '../../components/BPMTable/TableComponents/TableWrapper/SetupTableData'
import tableCreatorCreatorFactoryCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import UserBayphonesTableCreator from '../../tableDefinitions/Bayphone/UserBayphonesTableCreator'

export default function UserBayphoneTable(props) {
    var tableCreatorCreator = tableCreatorCreatorFactoryCreator.getTableCreatorCreatorFromIdentifier(UserBayphonesTableCreator.getId(), {tcFilters: props.filters})
    tableCreatorCreator.setParentProps(props)
    const tableCreator = tableCreatorCreator.getTableCreator("My Bayphones History")

    return (
        <Table
            TableCreator={tableCreator}
            stickyHeader
        />
    )
}

